import { render } from "./FeedbackVideo.vue?vue&type=template&id=20220274"
import script from "./FeedbackVideo.vue?vue&type=script&lang=js"
export * from "./FeedbackVideo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__